import { type UseQueryOptions } from "@tanstack/react-query";

import { getUniversalSearchResults } from "@/app/api/screeners";
import { useAuthedQuery } from "@/hooks/queries/use-authed-query.hook";
import type { UniversalSearchResult } from "@/types/universal-search";

const UNIVERSAL_SEARCH_QUERY_KEYS = {
  base: ["UNIVERSAL_SEARCH"] as const,
  query: (query: string) =>
    [...UNIVERSAL_SEARCH_QUERY_KEYS.base, query] as const,
};

export const useUniversalSearchQuery = (
  query = "",
  config: Partial<UseQueryOptions<UniversalSearchResult[]>> = {},
) => {
  return useAuthedQuery({
    placeholderData: (previousData) => (query ? (previousData ?? []) : []),
    queryFn: () => getUniversalSearchResults(query),
    queryKey: UNIVERSAL_SEARCH_QUERY_KEYS.query(query),
    ...config,
  });
};
